import React, { useEffect, useMemo } from 'react';
import { matchPath, useHistory, useLocation, useParams } from 'react-router-dom';
import _ from 'lodash';
import { route } from '~/app/helpers/route';

import usePageTitle from '~/app/hooks/usePageTitle';
import useTranslation from '~/app/hooks/useTranslation';

import { useAppHeader } from '~/app/modules/appHeader';

import { Machine } from '~/types';

import { useStoreActions, useStoreState } from '~/store';

import { MACHINES_DETAILS_ROUTES } from '~/machines/Details/Router';

import List from './List';
import Header from '~/issueService/Header';
import EmptyMessage from '~/issueService/EmptyMessage';
import { ROUTES } from "~/app/Router";
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import { TASK_ROUTES } from '~/tasks/Router';

type IssueProps = {
  fromTask?: boolean;
};

export type IssueComponent = React.FC<IssueProps>;

const Issues: IssueComponent = ({ fromTask = false }) => {
  const { id } = useParams<{ id: Machine['id'] }>();
  
  const { t } = useTranslation('machine.details');

  const history = useHistory();
  const { setData } = useAppHeader();
  const location = useLocation();

  const showOnlyOpenCriticalIssues = useMemo(() => (
    matchPath(location.pathname, MACHINES_DETAILS_ROUTES.openCriticalIssues)
  ), [location.pathname]);

  const machine = useStoreState(state => state.machine.data);
  const issues = useStoreState(state => showOnlyOpenCriticalIssues ? state.issue.filteredOpenIssues : state.issue.filteredIssues);
  const issueCounts = useStoreState(state => state.issue.issueCounts);
  const setIsCategorySearchOpen = useStoreActions(actions => actions.issue.setIsCategorySearchOpen);
  const setCategorySearchText = useStoreActions(actions => actions.issue.setCategorySearchText);
  const showIssueHistory = !fromTask && !showOnlyOpenCriticalIssues;

  usePageTitle(fromTask ? (machine.name || '').toUpperCase() : t('errorStatus'));

  useEffect(() => {
    setData({
      title: fromTask ? (machine.name || '').toUpperCase() : t('errorStatus'),
      subTitle: `${machine.intern} - ${machine.name}`.toUpperCase(),
      backLink: fromTask ? route(TASK_ROUTES.list) : (history.length > 1 ? history.goBack : route(ROUTES.projects)),
      showUser: false,
      machineId: '',
      projectId: '',
      showMachineMessages: false,
      isIssueDetailPage: false,
      isServiceDetailPage: false,
      notification: false,
      search: false,
      issueCategorySearch: showIssueHistory
    });
  }, [setData, id, machine, t, history, fromTask, showIssueHistory]);

  useEffect(() => {
    return () => {
      setIsCategorySearchOpen(false);
      setCategorySearchText('');
      setData({ issueCategorySearch: false });
    };
  }, [setIsCategorySearchOpen, setCategorySearchText, setData]);

  return (
    <>
      {showIssueHistory && <Header type={IssueOrServiceType.ISSUE} counts={issueCounts} />}
      {issues.length ? <List list={_.orderBy(issues, ['statusDate'], ['desc'])} /> : <EmptyMessage type={IssueOrServiceType.ISSUE}/>}
    </>
  );
};
export default Issues
